import Vue from "vue";
import api from "@/api/api-list";

let wx = require("weixin-js-sdk");
export const getWeChatConfig = async () => {
  if (Vue.prototype.$wechat) {
    return Vue.prototype.$wechat;
  } else {
    try {
      let res = await api.user.getWeChatJsConfig({ url: location.href });
      let jsApiList = [
        "onMenuShareAppMessage",
        "onMenuShareTimeline",
        "chooseWXPay",
        "scanQRCode",
      ];
      wx.config({
        debug: false,
        ...res.data,
        jsApiList,
        openTagList: [
          "wx-open-launch-weapp",
          "wx-open-launch-app",
          "wx-open-subscribe",
        ],
      });
      wx.miniProgram.getEnv((res) => {
        Vue.prototype.$isWxMini = res.miniprogram;
      });
      Vue.prototype.$wechat = wx;
      window.wx = wx;
      return wx;
    } catch (e) {
      console.log(e);
    }
  }
};
